/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Method_NoteInputs */

const ja_playdata_about_method_note = /** @type {(inputs: Playdata_About_Method_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`視聴者数や配信時間、その他すべてのデータは、取得時のプラットフォームの稼働状況と更新状態に影響を受けることがあります。そのため、これらのデータの正確性については完全には保証できない場合があります。`)
};

const en_playdata_about_method_note = /** @type {(inputs: Playdata_About_Method_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewer counts, broadcast durations and all other data can be affected by the operating and update state of each platform at the time of collection, so complete accuracy cannot be guaranteed.`)
};

/**
* | output |
* | --- |
* | "Viewer counts, broadcast durations and all other data can be affected by the operating and update state of each platform at the time of collection, so comple..." |
*
* @param {Playdata_About_Method_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_method_note = /** @type {((inputs?: Playdata_About_Method_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Method_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_method_note(inputs)
	return en_playdata_about_method_note(inputs)
});